module.exports = __webpack_public_path__ + "img/hakhak_books.27fab949.png";